import { InputType, TrackersFilterTypeIds, TrackersFilterTypes } from "./types";

export const TrackersFilterTypeIdMap: Record<
  TrackersFilterTypes,
  TrackersFilterTypeIds
> = {
  audio_types: "audioType",
  channels: "channelId",
  master_accounts: "masterAccountId",
  messages: "messageId",
  playTimeEnd: "playTimeEnd",
  playTimeStart: "playTimeStart",
  songs: "songId",
  status: "status",
  zones: "zoneId",
};

export const selectInputs = [
  { label: "Songs", name: "songs", placeholder: "Any song" },
  {
    label: "Channels",
    name: "channels",

    placeholder: "Any channel",
  },
  {
    label: "Audio Types",
    name: "audio_types",

    placeholder: "Any audio",
  },
  {
    label: "Master Accounts",
    name: "master_accounts",
    placeholder: "Any master account",
  },
  { label: "Zones", name: "zones", placeholder: "Any zone" },
  {
    label: "Messages",
    name: "messages",
    placeholder: "Any message",
  },
] as InputType[];
